import $ from 'jquery';
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';
import '../scss/campaigns/campaignApplication.scss';

window.jQuery = window.$ = $;
window.Toastify = Toastify;
